module.exports = __webpack_public_path__ + "img/login_desktop.667fe1f4.jpg";